import React, { useContext } from "react"
import useDate from "../../hooks/useDate"
import { isLifetimeSubscription } from "../../constants/lifetimePromoCodes"
import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from "react-router-dom"
import { SubscriptionCtx } from "../../context/subscriptionContext"
import { UserCtx } from "../../context/userContext"

const PrivateRouteCoach = () => {
  const { user } = useContext(UserCtx)
  const { activeSubscription } = useContext(SubscriptionCtx)
  const { iso, now } = useDate()
  const location = useLocation()
  const [searchParams] = useSearchParams()

  if (!user) {
    return (
      <Navigate
        to="/sign-in"
        state={{
          storageAvailable: true,
          pathname: location.pathname,
          searchParams: Object.fromEntries(searchParams.entries()),
        }}
      />
    )
  }

  if (!user.isCoach) {
    return <Navigate to="/member" />
  }

  const trialActive = iso(user.trialExpiration) > now
  const lifetime = isLifetimeSubscription(
    activeSubscription?.subscription_promo_code
  )

  const hasSubscription =
    user.isSubscribed ||
    Object.keys(activeSubscription || {}).length > 0

  if (!hasSubscription && !trialActive && !lifetime) {
    return <Navigate to="/coach/subscription/current" />
  }

  return <Outlet />
}

export default PrivateRouteCoach
